import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { ManagedProduct } from '../managed-macro-category';

export const managedColumns: Column<ManagedProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
    key: 'newContractCode',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderQuantity,
    key: 'quantity',
    type: 'number',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCurrency,
    key: 'currency',
    type: 'string',
  },
  {
    headerLabel:
      walletFinancialPositionsMessages.tableHeaderAveragePurchasePrice,
    key: 'averagePurchasePrice',
    type: 'amount',
  },
  {
    headerLabel:
      walletFinancialPositionsMessages.tableHeaderAveragePurchaseExchange,
    key: 'averagePurchaseExchange',
    type: 'number',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderShareDividedValue,
    key: 'currencyShareValue',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderChange,
    key: 'exchange',
    type: 'number',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderDate,
    key: 'date',
    type: 'date',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValue,
    key: 'equivalent',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderGainEuros,
    key: 'gainEur',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderGainPercentage,
    key: 'gainPercentage',
    type: 'percentage',
  },
];
